import {Card, Row, Tag} from "antd";
import { styled } from "styled-components";

export const StyledRentTypeTag = styled(Tag)`
    display: flex;
    align-items: center;
    font-size: 8px;
    font-weight: bold;
    border: none;
    border-radius: 15px;
background-color: var(--secondColor);
    color: var(--customWhite);
`;
